"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var HelpCircleSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,16 C5.13400675,16 2,12.8659932 2,9 C2,5.13400675 5.13400675,2 9,2 C12.8659932,2 16,5.13400675 16,9 C16,12.8659932 12.8659932,16 9,16 Z M9,15 C12.3137085,15 15,12.3137085 15,9 C15,5.6862915 12.3137085,3 9,3 C5.6862915,3 3,5.6862915 3,9 C3,12.3137085 5.6862915,15 9,15 Z M8,8 L7,8 C7,6.71336167 7.7225361,6 9,6 C10.2774639,6 11,6.71336167 11,8 C11,8.81151672 10.4865137,9.53417606 9.72017626,9.80117097 L9.33549636,9.93519493 C9.13460664,10.0051857 9,10.1946255 9,10.4073586 L9,11 L8,11 L8,10.4073586 C8,9.76915924 8.40381993,9.20083978 9.00648908,8.99086754 L9.39116897,8.85684359 C9.755727,8.72983017 10,8.38605047 10,8 C10,7.26303743 9.7225361,7 9,7 C8.2774639,7 8,7.26303743 8,8 Z M8,12 L9,12 L9,13 L8,13 L8,12 Z" })));
};
HelpCircleSmall.displayName = 'HelpCircleSmall';
exports.default = HelpCircleSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=HelpCircleSmall.js.map